import helpers, { hasBodyClass } from "../../js/helpers.js";
hasBodyClass("product-template") && import("../../js/prodify.js");

export function start() {}
